import styled from 'styled-components';
import Input from 'components/ui/Input';
import Label from 'components/ui/Label';

import { colours } from 'themes/default';

const MandatoryFieldLabel = styled(Label)`
  font-weight: bold;

  &::after {
    content: ' *';
    color: red;
  }
`;

const BillingDetailsInput = styled(Input)`
  line-height: 1;
  box-sizing: border-box;
`;

const CountryCodeInput = styled(BillingDetailsInput)`
  width: 45px;
  margin-right: 20px;
`;

const PhoneNumberInput = styled(BillingDetailsInput)`
  width: calc(100% - 65px);
`;

const Field = styled.div`
  margin: 0.4em 0;
`;

const CurrencyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ClearButton = styled.span`
  cursor: pointer;
  color: ${colours.Shades.TintBlue40};
`;

export { BillingDetailsInput, MandatoryFieldLabel, CountryCodeInput, PhoneNumberInput, Field, CurrencyContainer, ClearButton };
